var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank-transfer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 812",
    d: "M1.01777 24.0006H14.4798C14.7657 24.0006 14.9976 23.7688 14.9976 23.4828V22.965C14.9976 22.6791 14.7657 22.4473 14.4798 22.4473H1.01777C0.731813 22.4473 0.5 22.6791 0.5 22.965V23.4828C0.5 23.7688 0.731813 24.0006 1.01777 24.0006Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 813",
    d: "M1.01777 15.9203H14.4798C14.7657 15.9203 14.9976 15.6885 14.9976 15.4025V14.8848H0.5V15.4025C0.5 15.6885 0.731813 15.9203 1.01777 15.9203Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 814",
    d: "M4.53829 11.9738L1.49121 14.3447H14.0057L10.9586 11.9738C10.7765 11.8323 10.5524 11.7556 10.3218 11.7559H5.17463C4.94417 11.7557 4.72023 11.8324 4.53829 11.9738Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 815",
    d: "M5.09668 20.8928C5.09668 21.1787 5.32849 21.4105 5.61445 21.4105H7.68553C7.97149 21.4105 8.2033 21.1787 8.2033 20.8928C8.2033 20.6068 7.97149 20.375 7.68553 20.375H5.61445C5.32849 20.375 5.09668 20.6068 5.09668 20.8928Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 816",
    d: "M7.68553 16.5859H5.61445C5.32849 16.5859 5.09668 16.8177 5.09668 17.1037C5.09668 17.3897 5.32849 17.6215 5.61445 17.6215H7.68553C7.97149 17.6215 8.2033 17.3897 8.2033 17.1037C8.2033 16.8177 7.97149 16.5859 7.68553 16.5859Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 817",
    d: "M5.56055 18.1328H7.63163V20.2039H5.56055V18.1328Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 818",
    d: "M1.01758 20.8928C1.01758 21.1787 1.24939 21.4105 1.53535 21.4105H3.60643C3.89238 21.4105 4.1242 21.1787 4.1242 20.8928C4.1242 20.6068 3.89238 20.375 3.60643 20.375H1.53535C1.24939 20.375 1.01758 20.6068 1.01758 20.8928Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 819",
    d: "M3.60643 16.5859H1.53535C1.24939 16.5859 1.01758 16.8177 1.01758 17.1037C1.01758 17.3897 1.24939 17.6215 1.53535 17.6215H3.60643C3.89238 17.6215 4.1242 17.3897 4.1242 17.1037C4.1242 16.8177 3.89238 16.5859 3.60643 16.5859Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 820",
    d: "M1.53564 18.1328H3.60672V20.2039H1.53564V18.1328Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 821",
    d: "M9.27539 20.8928C9.27539 21.1787 9.5072 21.4105 9.79316 21.4105H11.8642C12.1502 21.4105 12.382 21.1787 12.382 20.8928C12.382 20.6068 12.1502 20.375 11.8642 20.375H9.79316C9.5072 20.375 9.27539 20.6068 9.27539 20.8928Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 822",
    d: "M11.8642 16.5859H9.79316C9.5072 16.5859 9.27539 16.8177 9.27539 17.1037C9.27539 17.3897 9.5072 17.6215 9.79316 17.6215H11.8642C12.1502 17.6215 12.382 17.3897 12.382 17.1037C12.382 16.8177 12.1502 16.5859 11.8642 16.5859Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 823",
    d: "M9.77734 18.1328H11.8484V20.2039H9.77734V18.1328Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 824",
    d: "M10.0024 4.14277C10.0024 4.42873 10.2342 4.66054 10.5202 4.66054H23.9822C24.2682 4.66054 24.5 4.42873 24.5 4.14277V3.625H10.0024V4.14277Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 825",
    d: "M19.8237 1.58087e-06H14.6766C14.4463 -5.56396e-05 14.2226 0.0766477 14.0408 0.217984L10.9932 2.58885H23.5077L20.4611 0.217983C20.2789 0.0763198 20.0545 -0.000401585 19.8237 1.58087e-06Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 826",
    d: "M16.7969 9.44746C16.7969 9.73341 17.0287 9.96523 17.3146 9.96523H19.3857C19.6717 9.96523 19.9035 9.73341 19.9035 9.44746C19.9035 9.1615 19.6717 8.92969 19.3857 8.92969H17.3146C17.0287 8.92969 16.7969 9.1615 16.7969 9.44746Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 827",
    d: "M23.9822 10.5879H10.5202C10.2342 10.5879 10.0024 10.8197 10.0024 11.1057V11.6234C10.0024 11.9094 10.2342 12.1412 10.5202 12.1412H23.9822C24.2682 12.1412 24.5 11.9094 24.5 11.6234V11.1057C24.5 10.8197 24.2682 10.5879 23.9822 10.5879Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 828",
    d: "M19.3857 4.67773H17.3146C17.0287 4.67773 16.7969 4.90955 16.7969 5.1955C16.7969 5.48146 17.0287 5.71327 17.3146 5.71327H19.3857C19.6717 5.71327 19.9035 5.48146 19.9035 5.1955C19.9035 4.90955 19.6717 4.67773 19.3857 4.67773Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 829",
    d: "M17.3682 6.32617H19.4392V8.39725H17.3682V6.32617Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 830",
    d: "M12.6182 9.44746C12.6182 9.73341 12.85 9.96523 13.1359 9.96523H15.207C15.493 9.96523 15.7248 9.73341 15.7248 9.44746C15.7248 9.1615 15.493 8.92969 15.207 8.92969H13.1359C12.85 8.92969 12.6182 9.1615 12.6182 9.44746Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 831",
    d: "M15.207 4.67773H13.1359C12.85 4.67773 12.6182 4.90955 12.6182 5.1955C12.6182 5.48146 12.85 5.71327 13.1359 5.71327H15.207C15.493 5.71327 15.7248 5.48146 15.7248 5.1955C15.7248 4.90955 15.493 4.67773 15.207 4.67773Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 832",
    d: "M13.1509 6.32617H15.222V8.39725H13.1509V6.32617Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 833",
    d: "M20.8755 9.44746C20.8755 9.73341 21.1073 9.96523 21.3933 9.96523H23.4643C23.7503 9.96523 23.9821 9.73341 23.9821 9.44746C23.9821 9.1615 23.7503 8.92969 23.4643 8.92969H21.3933C21.1073 8.92969 20.8755 9.1615 20.8755 9.44746Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 834",
    d: "M23.4643 4.67773H21.3933C21.1073 4.67773 20.8755 4.90955 20.8755 5.1955C20.8755 5.48146 21.1073 5.71327 21.3933 5.71327H23.4643C23.7503 5.71327 23.9821 5.48146 23.9821 5.1955C23.9821 4.90955 23.7503 4.67773 23.4643 4.67773Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 835",
    d: "M21.3926 6.32617H23.4637V8.39725H21.3926V6.32617Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 836",
    d: "M5.75488 8.44274V11.0316C5.75488 11.3175 5.9867 11.5494 6.27265 11.5494C6.55861 11.5494 6.79042 11.3175 6.79042 11.0316V8.44274C6.79042 7.58487 7.48586 6.88943 8.34373 6.88943H10.2005L10.0487 7.04114C9.84649 7.24328 9.84649 7.57112 10.0487 7.77332C10.2509 7.97552 10.5787 7.97552 10.7809 7.77332L11.8164 6.73773C12.0185 6.53554 12.0185 6.20779 11.8164 6.0056L10.7809 4.97006C10.5787 4.7678 10.2509 4.7678 10.0487 4.97C9.84649 5.17221 9.84649 5.50004 10.0487 5.70224L10.2005 5.85389H8.34373C6.91466 5.8556 5.75659 7.01367 5.75488 8.44274Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 837",
    d: "M14.951 16.2253C14.7488 16.0232 14.4211 16.0232 14.2189 16.2253L13.1833 17.2609C12.9812 17.463 12.9812 17.7908 13.1833 17.993L14.2189 19.0285C14.421 19.2308 14.7489 19.2308 14.9511 19.0286C15.1533 18.8264 15.1533 18.4985 14.9511 18.2963L14.7993 18.1447H16.656C18.0851 18.143 19.2432 16.9849 19.2449 15.5558V12.967C19.2449 12.681 19.0131 12.4492 18.7271 12.4492C18.4411 12.4492 18.2093 12.681 18.2093 12.967V15.5558C18.2093 16.4137 17.5139 17.1091 16.656 17.1091H14.7993L14.951 16.9574C15.1531 16.7553 15.1531 16.4275 14.951 16.2253Z",
    fill: "#42A4D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.4a2d722779f31640b2825a7e14c4b894.svg";
export { ForwardRef as ReactComponent };